import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

export const tablePaginationStyles = makeStyles((theme: Theme) =>
    createStyles({
        paginationWrapper: {
            display: "flex",
            width: "fit-content",
            wordSpacing: "4px",
        },
        paginationInputField: {
            "& .MuiInputBase-input": {
                "-moz-appearance": "textfield",
                padding: 0,
            },
            "& .MuiInputBase-input::-webkit-outer-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
            "& .MuiInputBase-input::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
                margin: 0,
            },
        },
    })
);
